export enum Fields {
    CardNo = 'cardNo',
    CVCNo = 'cvcNo',
}

export type GiftCardFormFields = {
    [Fields.CardNo]: string;
    [Fields.CVCNo]: string;
};
